import React from 'react';
import { motion } from 'framer-motion';
import { Card } from '../ui/Card';
const ingredients = [{
  name: 'Horse Chestnut',
  title: 'The "vein strengthener"',
  desc: 'Supports strong, resilient vein walls and healthy circulation in stubborn areas like the pelvis and legs.',
  image: 'https://cdn.magicpatterns.com/uploads/b3LdfzAeM7Rsu8RE3TAkTE/9.jpg'
}, {
  name: "Butcher's Broom",
  title: 'The "vein tonic"',
  desc: 'Traditionally used to reduce pooling and support vein tone — key for easing pelvic congestion.',
  image: 'https://cdn.magicpatterns.com/uploads/wDhfFMBUizJSzV5HPc2hDC/10.jpg'
}, {
  name: 'Grape Seed Extract',
  title: 'The antioxidant shield',
  desc: 'Helps protect blood vessels and support microcirculation so blood can move freely instead of backing up.',
  image: 'https://cdn.magicpatterns.com/uploads/jqbXzG88RsgzidsJateh88/11.jpg'
}, {
  name: 'Maca Root',
  title: 'The prostate supporter',
  desc: 'Supports male vitality and healthy prostate size without altering hormones.',
  image: 'https://cdn.magicpatterns.com/uploads/w3gryEmApudXBfqsCCSeeP/12.jpg'
}];
export function Ingredients() {
  return <section className="py-20 bg-[#020617]" data-id="element-150">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-151">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-152">
          <span className="text-emerald-400 font-bold tracking-wider uppercase text-lg" data-id="element-153">
            Premium Liquid Formula
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mt-2 mb-6" data-id="element-154">
            Inside Every Bottle: 8 Clinically-Studied Botanicals Working In
            Synergy
          </h2>
          <p className="text-slate-300 text-xl" data-id="element-155">
            Horse chestnut, butcher's broom, grape seed, maca, stoneroot,
            motherwort, hawthorn, and more — chosen to support circulation, vein
            tone, and nighttime calm.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-156">
          {ingredients.map((item, idx) => <motion.div key={item.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: idx * 0.1
        }} viewport={{
          once: true
        }} data-id="element-157">
              <Card className="h-full border-slate-700 hover:border-emerald-500 transition-colors duration-300 bg-slate-800/50" data-id="element-158">
                <div className="p-6" data-id="element-159">
                  <div className="w-20 h-20 rounded-xl overflow-hidden mb-4 border-2 border-slate-700 mx-auto md:mx-0" data-id="element-160">
                    <img src={item.image} alt={item.name} className="w-full h-full object-cover" data-id="element-161" />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-1 text-center md:text-left" data-id="element-162">
                    {item.name}
                  </h3>
                  <p className="text-base font-bold text-emerald-400 uppercase tracking-wide mb-3 text-center md:text-left" data-id="element-163">
                    {item.title}
                  </p>
                  <p className="text-slate-300 text-lg leading-relaxed text-center md:text-left" data-id="element-164">
                    {item.desc}
                  </p>
                </div>
              </Card>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-165">
          <p className="text-lg text-slate-400 font-medium bg-slate-800/50 inline-block px-6 py-2 rounded-full border border-slate-700 shadow-sm" data-id="element-166">
            All ingredients are 100% natural, non-GMO, and free from synthetic
            additives.
          </p>
        </div>
      </div>
    </section>;
}